import axios from "axios";
import { store } from "@/app/store";

const rawApiBaseUrl = import.meta.env.VITE_API_URL?.trim();

const stripTrailingBackendSegments = (pathname: string) =>
  pathname.replace(/\/+$/, "").replace(/\/v1$/, "").replace(/\/api$/, "");

export const API_BASE_URL = rawApiBaseUrl
  ? rawApiBaseUrl.replace(/\/+$/, "")
  : "https://sandybrown-gazelle-155127.hostingersite.com/api";

export const STORAGE_BASE_URL = (() => {
  if (!rawApiBaseUrl || !/^https?:\/\//i.test(API_BASE_URL)) {
    return "";
  }

  try {
    const url = new URL(API_BASE_URL);
    url.pathname = stripTrailingBackendSegments(url.pathname);
    return `${url.origin}${url.pathname}`.replace(/\/$/, "");
  } catch {
    return "";
  }
})();

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "ngrok-skip-browser-warning": "true",
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const state = store.getState();
  if (state.auth.token) {
    config.headers.Authorization = `Bearer ${state.auth.token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Any 401 means the current token/session is no longer valid.
    // Clear local auth so the app can redirect back to login instead of retrying protected requests.
    if (error.response?.status === 401) {
      store.dispatch({ type: "auth/logout" });
    }
    return Promise.reject(error);
  },
);

export default api;
